<template>
  <div class="detail-page">
    <!-- 头部面包屑以及文字，和编辑功能 -->
    <BreadCrumb :data="breadcrumb" :title="'杂志详情管理'" />
    <El-button v-if="!isEditting" @click="edit()" class="edit-btn"
      >编辑</El-button
    >
    <!-- 大学详情页基本信息 -->
    <DIV v-show="!isEditting" class="detail-form-information">
      <h2>基本信息</h2>
      <div class="form-content">
        <!-- 左边边图片 -->
        <div>
          <img
            v-if="magazineDetail.cover_image"
            :src="magazineDetail.cover_image"
            alt=""
            class="form-content-img logo"
          />
          <img
            v-else
            src="../../../../static/image/no-img.png"
            alt=""
            class="form-content-img cover"
          />
        </div>
        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="exclusive">
            <h4>标题</h4>
            <span>{{ magazineDetail.title }}</span>
          </li>

          <li class="exclusive">
            <h4>简介</h4>
            <span v-if="magazineDetail.introduce != null">{{
              magazineDetail.introduce
            }}</span>
            <span v-if="magazineDetail.introduce == null">暂无</span>
          </li>
          <li class="half">
            <h4>时间</h4>
            <div class="area-li-div">
              <span v-if="magazineDetail.year != null">{{
                magazineDetail.year
              }}</span>
              <span v-if="magazineDetail.month != null">{{
                magazineDetail.month
              }}</span>
              <span
                v-if="
                  magazineDetail.year == null && magazineDetail.month == null
                "
                >暂无</span
              >
            </div>
          </li>
          <li class="half">
            <h4>期刊</h4>
            <div class="area-li-div">
              <span v-if="magazineDetail.vol != null"
                >Vol {{ magazineDetail.vol }}</span
              >
              <span v-if="magazineDetail.issue != null"
                >Issue {{ magazineDetail.issue }}</span
              >
              <span
                v-if="
                  magazineDetail.vol == null && magazineDetail.issue == null
                "
                >暂无</span
              >
            </div>
          </li>
          <li class="half">
            <h4>状态</h4>
            <el-switch
              v-model="magazineDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              disabled
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
    </DIV>

    <!-- 修改大学详情基本信息页 -->
    <div v-show="isEditting" class="detail-form-information">
      <h2>修改信息</h2>
      <div class="form-content">
        <!-- 左边边图片 -->
        <div class="imgbox">
          <UploadImage
            :img="magazineDetail.cover_image"
            :width="150"
            :height="200"
            @getUploadImage="getUploadCoverImage"
            class="form-content-img"
          ></UploadImage>
        </div>
        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="exclusive">
            <h4>标题</h4>
            <el-input
              v-model="magazineDetail.title"
              placeholder="请输入标题"
            ></el-input>
          </li>

          <li class="exclusive">
            <h4 class="choice">简介</h4>
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="magazineDetail.introduce"
            >
            </el-input>
          </li>
          <li class="half">
            <h4 class="choice">年</h4>
            <el-date-picker
              v-model="magazineDetail.year"
              value-format="yyyy"
              type="year"
              placeholder="选择年份"
            >
            </el-date-picker>
          </li>
          <li class="half">
            <h4 class="choice">月</h4>
            <el-select v-model="magazineDetail.month" placeholder="选择月份">
              <el-option label="January" value="January"></el-option>
              <el-option label="February" value="February"></el-option>
              <el-option label="March" value="March"></el-option>
              <el-option label="April" value="April"></el-option>
              <el-option label="May" value="May"></el-option>
              <el-option label="June" value="June"></el-option>
              <el-option label="July" value="July"></el-option>
              <el-option label="August" value="August"></el-option>
              <el-option label="September" value="September"></el-option>
              <el-option label="October" value="October"></el-option>
              <el-option label="November" value="November"></el-option>
              <el-option label="December" value="December"></el-option>
            </el-select>
          </li>
          <li class="half">
            <h4 class="choice">Vol</h4>
            <el-input-number
              v-model.number="magazineDetail.vol"
              placeholder=""
            ></el-input-number>
          </li>
          <li class="half">
            <h4 class="choice">Issue</h4>
            <el-input-number
              v-model.number="magazineDetail.issue"
              placeholder=""
            ></el-input-number>
          </li>
          <li class="half">
            <h4>状态</h4>
            <el-switch
              v-model="magazineDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
    </div>

    <MagazineThemeManagement
      v-if="$route.query.method != 'add'"
      :magazineDetail="magazineDetail"
      :isEditting="isEditting"
    />

    <SaveGroup
      :isEditting="isEditting"
      @cancelUpdate="cancelUpdate"
      @save="save"
      @recover="recover"
      @view="view"
      @cancelAdd="cancelAdd"
      @add="add"
    />
  </div>
</template>
<script>
import UploadImage from "../../componentSet/uploadImage.vue";
import BreadCrumb from "../../componentSet/BreadCrumb";
import MagazineThemeManagement from "./components/MagazineThemeManagement";

import {
  magazineDetail_Api,
  getMagazineDetail_Api,
  updateMagazineDetail_Api,
} from "../../../apis/magazine.api";
import SaveGroup from "../../componentSet/SaveGroup.vue";

export default {
  components: {
    SaveGroup,
    UploadImage,
    MagazineThemeManagement,
    BreadCrumb,
  },
  computed: {
    breadcrumb: function () {
      return [
        {
          name: "首页",
          link: "/admin/main",
        },
        { name: "杂志列表", link: "/admin/newMagazine" },
        {
          name: `${this.magazineDetail.title ? this.magazineDetail.title : ""}`,
          link: "/admin/newMagazineDetail",
        },
      ];
    },
  },
  data() {
    return {
      selectedTheme: null,
      isEditting: false,
      magazineDetail: {
        id: null,
        year: "",
      },
      content: "",
      addressList: [],
    };
  },
  mounted() {
    if (this.$route.query.method == "update") {
      this.magazineDetail.id = this.$route.query.id;
      this.getMagazineDetail();
    } else {
      this.isEditting = true;
    }
  },
  methods: {
    getUploadCoverImage(img_url) {
      this.magazineDetail.cover_image = img_url;
    },
    removeImgae(index) {
      this.magazineDetail.images.splice(index, 1);
    },

    getUploadMagazineImage(img_url) {
      this.magazineDetail.images.unshift(img_url);
      console.log(this.magazineDetail.images);
      // this.magazineDetail.images = img_url;
    },
    getMagazineDetail(hint) {
      magazineDetail_Api(this.magazineDetail.id).then((res) => {
        hint ? this.$global.success(this, hint) : "";

        this.magazineDetail = res.data;
        if (!this.magazineDetail.title == null) {
          this.magazineDetail.title = "";
        }
        if (!this.magazineDetail.introduce == null) {
          this.magazineDetail.introduce = "";
        }
        console.log(this.magazineDetail);
      });
    },
    // save group 回调函数
    cancelUpdate() {
      this.getMagazineDetail("取消成功");
      this.isEditting = false;
    },
    recover() {
      this.getMagazineDetail("恢复成功");
    },
    view() {
      window.open(
        "http://guihua.wupen.org/magazine/" + this.$route.query.id,
        "_blank"
      );
    },
    cancelAdd() {
      window.close();
    },
    add() {
      let formattedData = this.validateForm(this.magazineDetail);
      if (!formattedData) {
        return;
      } else {
        getMagazineDetail_Api(formattedData)
          .then((res) => {
            this.magazineDetail = res.data;
            this.isEditting = false;
            this.getMagazineDetail();
            this.$router.push({
              path: "/admin/newMagazineDetail",
              query: { id: res.data.id, method: "update" },
            });
            this.$global.success(this, "创建成功！", null);
          })
          .catch((err) => {
            this.$global.error(this, "创建失败！", null);
          });
      }
    },
    save() {
      let formattedData = this.validateForm(this.magazineDetail);
      if (!formattedData) {
        return;
      } else {
        updateMagazineDetail_Api(formattedData)
          .then((res) => {
            if (res.code === 205) {
              this.$global.success(this, "更新成功");
              this.getMagazineDetail();
              this.isEditting = false;
            } else {
              this.$global.error(this, "更新失败！", null);
            }
          })
          .catch(() => {
            this.$global.error(this, "更新失败！", null);
          });
      }
    },
    edit() {
      this.isEditting = true;
    },
    validateForm(formData) {
      //表单校验

      // formData.image_list = formData.images;
      formData.magazine_id = formData.id;
      // formData.keywords = formData.tags;
      console.log(formData);
      return formData;
    },
  },
};
</script>
<style lang="scss" scoped>
.university-images {
  @include box-model;
  .images-box {
    overflow-y: hidden;
    overflow-x: auto;
    display: flex;
    height: 170px;
    .upload-image {
      margin-right: 20px;
    }
    .image-list {
      display: flex;
      .image-item {
        position: relative;
        display: inline-block;
        margin-right: 20px;
        img {
          height: 140px;
        }
        .el-icon-error {
          color: $base-color;
          cursor: pointer;
          position: absolute;
          top: 10px;
          right: 10px;
        }
      }
      .image-item:last-child {
        margin-right: 0px;
      }
    }
  }
}
.form-content .logo {
  width: 150px;
  height: 200px !important;
}
.form-content .cover {
  width: 220px;
  height: 120px;
}
.form-content .logo {
  width: 150px;
  height: 120px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/guihua/NewMagazineDetail.vue